export default __webpack_public_path__ + "static/media/transactions.4b26f659.svg";